<template>
    <div id="game">
        <div class="container">

            <div class="progress_timer">
                <div class="timer">{{games.timer}}</div>
                <div class="progress" :style="{'width': (games.timer / 100) / 45 * 10000 + '%'}"></div>
            </div>

            <div class="total_score">
                <span>{{games.totalScore}} <i class="fa fa-sack-dollar ml"></i></span>
            </div>

            <div class="quize_field">
                <span v-if="games.loaded">
                    {{games.currentQuize}}
                </span>
                <div class="loading" v-else>
                    <div></div>
                </div>
            </div>

            <div class="helper">
                <div @click="help(1)" class="help_icon" :class="{'disable_help': helpers.replaceQuiz}">
                    <i class="far fa-sync-alt"></i>
                    <div class="disable" :class="{'disabled': helpers.replaceQuiz}">
                        <i class="fal fa-times" aria-hidden="true"></i>
                    </div>
                </div>
                <div @click="help(2)" class="help_icon" :class="{'disable_help': helpers.removeWrong}">
                    <i class="far fa-adjust"></i>
                    <div class="disable" :class="{'disabled': helpers.removeWrong}">
                        <i class="fal fa-times" aria-hidden="true"></i>
                    </div>
                </div>
                <div @click="help(3)" class="help_icon" :class="{'disable_help': helpers.doubleChoise}">
                    <i class="far fa-check-double"></i>
                    <div class="disable" :class="{'disabled': helpers.doubleChoise}">
                        <i class="fal fa-times" aria-hidden="true"></i>
                    </div>
                </div>
                <div @click="help(4)" class="help_icon" :class="{'disable_help': helpers.friendHelp}">
                    <i class="far fa-phone-alt"></i>
                    <div class="disable" :class="{'disabled': helpers.friendHelp}">
                        <i class="fal fa-times" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
            
            <div class="answers" v-if="games.loaded">
                <div @click="check(answer.ind, incAns.includes(answer.value))" 
                class="answer_card" 
                v-for="(answer, index) in games.answers" :key="answer.ind"
                :class="{'active': games.checked == answer.ind || doubleCheck.check2 == answer.ind, 
                'correct': games.corrected == answer.ind || doubleCheck.corrected == answer.ind,
                'incorrect': games.incorrected == answer.ind || doubleCheck.incorrected == answer.ind,
                'disabled': incAns.includes(answer.value)}">
                    <div class="index">{{ansin[index]}}</div>
                    <div class="value">{{answer.value}}</div>
                </div>
            </div>
            <div class="loading" v-else>
                <div></div>
            </div>
        </div>

        <div @click="scoresShow = false" class="scores" :class="{'scores_show':scoresShow}">
            <div class="scores_card" @click.stop="scoreShow" :class="{'scores_card_show':scoresShow}">
                <div class="scores_so">
                    <div class="score" v-for="i in scoresList" :key="i">
                        <i v-if="games.currentScore == i" class="fa fa-arrow-right" aria-hidden="true"></i>
                        <span :class="{'current ml' : games.currentScore == i}">
                            {{ i }} <i class="far fa-coins ml"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="scores_btn" @click="scoresShow = !scoresShow">
            <i class="fa fa-sort-amount-up" aria-hidden="true"></i>
        </div>

        <div class="modal" :class="{'modal_show': gameOver.over}">
            <div class="modal_card" :class="{'modal_card_show': gameOver.over}">
                <div class="title" 
                :class="{'incorrect':gameOver.status == 'incorrect', 'winner':gameOver.status == 'winner'}">
                    {{gameOver.title}} 
                </div>
                <div class="body">Ishlandi: {{games.totalScore}} <i class="far fa-coins" aria-hidden="true"></i></div>

                <div class="game_icons">
                    <div class="gic" @click="game({prop: 'running', val: false})">
                        <div class="ic">
                            <i class="fad fa-arrow-to-left" aria-hidden="true"></i>
                        </div>
                        <div class="text">
                            Bosh sahifaga
                        </div>
                    </div>
                    <div class="gic" @click="newGame()">
                        <div class="ic">
                            <i class="fad fa-play" aria-hidden="true"></i>
                        </div>
                        <div class="text">
                            Yana o'ynash
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" :class="{'modal_show': friendHelpShow}">
            <div class="modal_card" :class="{'modal_card_show': friendHelpShow}">
                <div class="title">Do'stingiz: </div>
                <div class="body">{{friendAns}}</div>
                <div class="dismiss">
                    <button @click="friendHelpShow = false">OK</button>
                </div>
            </div>
        </div>

        <div class="modal" :class="{'modal_show': doubleCheckHelpShow}">
            <div class="modal_card" :class="{'modal_card_show': doubleCheckHelpShow}">
                <div class="title">2ta javob</div>
                <div class="body">Sizda 2marotaba javob berish imkoni mavjud. Agar 1marta xato javob bersangiz yutqazmaysiz.</div>
                <div class="dismiss">
                    <button @click="doubleCheckHelpShow = false">OK</button>
                </div>
            </div>
        </div>

        <div class="modal" :class="{'modal_show': getHelpShow}">
            <div class="modal_card" :class="{'modal_card_show': getHelpShow}">
                <div class="title">Diqqat!</div>
                <div class="body">Har bir savol uchun faqat bir marotaba yordam olishingiz mumkin! Siz yordam olib bo'ldingiz.</div>
                <div class="dismiss">
                    <button @click="getHelpShow = false">OK</button>
                </div>
            </div>
        </div>

        <div class="modal" :class="{'modal_show': connection}">
            <div class="modal_card" :class="{'modal_card_show': connection}">
                <div class="title incorrect">XATOLIK</div>
                <div class="body">Serverga ulnishda xatolik! Iltimos qaytadan urunib ko'ring. Agarda shu xol yana takrorlansa bizga 
                    <a class="link" href="https://t.me/raupov_manuchehr">murojaat qiling.</a>
                </div>
                <div class="dismiss">
                    <button @click="game({prop: 'running', val: false})">OK</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {gameControls} from "../gameControls"
import {mapActions} from "vuex"
export default {
    mixins: [gameControls],

    data() {
        return {
            scoresShow: false,
        }
    },

    methods: {
        ...mapActions([
            "game"
        ])
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/game";
</style>